/** Live streaming configuration — mirrors mobile LiveConfig / LiveTimeouts */

export const LIVE_API_BASE = '/live-streams'

export const LIVE_PHASES = {
  IDLE: 'idle',
  PREVIEWING: 'previewing',
  RECOVERING: 'recovering',
  VALIDATING: 'validating',
  SOCKET_CONNECTING: 'socketConnecting',
  LIVEKIT_CONNECTING: 'livekitConnecting',
  CONNECTING: 'connecting',
  CONNECTED_HOST: 'connectedHost',
  CONNECTED_VIEWER: 'connectedViewer',
  RECONNECTING: 'reconnecting',
  ENDING: 'ending',
  ENDED: 'ended',
  ERROR: 'error',
}

export const LIVE_END_REASONS = {
  HOST_ENDED: 'hostEnded',
  MAX_DURATION: 'maxDurationReached',
  KICKED: 'kicked',
  BANNED: 'banned',
  NETWORK: 'networkError',
  PRIVACY: 'privateAccessDenied',
  ERROR: 'error',
  UNKNOWN: 'unknown',
}

export const LIVE_DEFAULTS = {
  defaultFeedLimit: 20,
  defaultCommentsLimit: 50,
  defaultViewersLimit: 20,
  maxChatMessages: 100,
  maxFloatingReactions: 30,
  maxTitleLength: 200,
  maxCommentLength: 500,
}

export const LIVE_TIMEOUTS = {
  livekitConnectionMs: 15000,
  reconnectTimeoutMs: 12000,
  settingsDebounceMs: 400,
  reactionThrottleMs: 1700,
  commentThrottleMs: 2000,
  pendingCommentMaxRetries: 6,
  tokenRefreshIntervalMs: 210 * 60 * 1000,
  feedRefreshMs: 30000,
  goLiveDelayMs: 5000,
}
